import { orderBy } from 'lodash';
import { createSelector } from 'reselect';
import { State } from 'store';

const getNoteState = (state: State) => state.notes;

// Raw store selectors
export const getNoteEntityList = createSelector(getNoteState, entities =>
  orderBy(entities.entities, [entity => entity.createdAt], ['desc']),
);
export const getNoteStatus = createSelector(getNoteState, entities => entities.status);
